import i18n from '@dms/i18n';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export function ConditionChips() {
  const {catalogueApi} = useVehicleFormContext();
  return (
    <Field
      type="chips"
      name="condition"
      label={i18n.t('entity.vehicle.labels.condition')}
      options={catalogueApi?.vehicleConditionOptions ?? []}
      isDeselectable
    />
  );
}
